import React from "react";

function IconLightBulb() {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M7 15h6l-.367 1.103a2.775 2.775 0 01-5.265 0L7 15z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.919 13.5l.59-1.772c.119-.354.317-.675.58-.94l.345-.344A3.638 3.638 0 0014.5 7.872 4.372 4.372 0 0010.128 3.5h-.256A4.372 4.372 0 005.5 7.872c0 .965.383 1.89 1.066 2.572l-.53.53-.531.53A5.138 5.138 0 014 7.873 5.872 5.872 0 019.872 2h.256A5.872 5.872 0 0116 7.872c0 1.362-.541 2.67-1.505 3.633l-.344.344a.902.902 0 00-.218.353L13 15H7l-.933-2.798a.902.902 0 00-.218-.353l-.344-.344.53-.53.53-.53.345.344c.264.264.462.585.58.939l.591 1.772h3.838z"
      />
    </svg>
  );
}

export default IconLightBulb;
